// extracted by mini-css-extract-plugin
export var completionBody = "_kl-2";
export var completionCard = "_kl-0";
export var completionFooter = "_kl-3";
export var completionTitle = "_kl-1";